module.exports = __webpack_public_path__ + "static/media/34DSS10.ba9c24b8.jpg";